import styles from './style.module.scss';
import { Row, Col, Descriptions, Spin } from 'antd';
import { Button, PageHeader } from 'components';
import { PlusOutlined, FilePdfOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import useCandidates from '../useCandidates';

const Single = () => {
  const { t } = useTranslation();
  const { singleItem, handleDownloadPdf, updateInProcess } =
    useCandidates(false);

  return (
    <div>
      <PageHeader title={t('Database candidati')} />
      <div className={styles.content}>
        <Descriptions column={1} bordered>
          {singleItem ? (
            <>
              <Descriptions.Item label={t('Outlet Village')}>
                {singleItem?.allData?.shopping_center_title}
              </Descriptions.Item>
              <Descriptions.Item label={t('Annuncio')}>
                {singleItem?.allData?.vacancies_count}
              </Descriptions.Item>
              <Descriptions.Item label={t('ID Candidato')}>
                {singleItem?.allData?.id}
              </Descriptions.Item>
              <Descriptions.Item label={t('Cognome')}>
                {singleItem?.allData?.surname}
              </Descriptions.Item>
              <Descriptions.Item label={t('Email')}>
                {singleItem?.allData?.email}
              </Descriptions.Item>
              <Descriptions.Item label={t('Nome')}>
                {singleItem?.allData?.name}
              </Descriptions.Item>
              <Descriptions.Item label={t('Settore')}>
                {singleItem?.allData?.vacancy_application_type?.title}
              </Descriptions.Item>
              <Descriptions.Item label={t('Profilo candidato')}>
                {singleItem?.allData?.vacancy_category?.title}
              </Descriptions.Item>
              <Descriptions.Item label={t('Sesso')}>
                {singleItem?.allData?.sex_short}
              </Descriptions.Item>
              <Descriptions.Item label={t('Fascia d’eta')}>
                {singleItem?.allData?.birthday_range_title}
              </Descriptions.Item>
              <Descriptions.Item label={t('Anni esp')}>
                {singleItem?.allData?.experience_year?.title}
              </Descriptions.Item>
              <Descriptions.Item label={t('Dispon. contratto')}>
                {singleItem?.allData?.contract_type?.title}
              </Descriptions.Item>
              <Descriptions.Item label={t('Provincia')}>
                {singleItem?.allData?.region?.title}
              </Descriptions.Item>
              <Descriptions.Item label={t('Lingua 1')}>
                {singleItem?.allData?.vacancy_language?.title}
              </Descriptions.Item>
              <Descriptions.Item label={t('Livello lingua 1')}>
                {singleItem?.allData?.vacancy_language_level}
              </Descriptions.Item>
              <Descriptions.Item label={t('Lingua 2')}>
                {singleItem?.allData?.vacancy_language2?.title}
              </Descriptions.Item>
              <Descriptions.Item label={t('Livello lingua 2')}>
                {singleItem?.allData?.vacancy_language2_level}
              </Descriptions.Item>
              <Descriptions.Item label={t('Wishlist')}>
                {singleItem?.allData?.wishlists_count}
              </Descriptions.Item>
            </>
          ) : (
            <Spin size={'large'} />
          )}
        </Descriptions>
      </div>
    </div>
  );
};

export default Single;
